import { render, staticRenderFns } from "./CustomerCallSheetArchiveTable.vue?vue&type=template&id=1f0ebd5e&scoped=true&"
import script from "./CustomerCallSheetArchiveTable.vue?vue&type=script&lang=ts&"
export * from "./CustomerCallSheetArchiveTable.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerCallSheetArchiveTable.vue?vue&type=style&index=0&id=1f0ebd5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0ebd5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VChip,VDataTable,VDivider,VTextField})
